import { IUser } from "@rentiohq/shared-frontend/dist/types/auth.types";
import utils from "@rentiohq/web-shared/dist/utils";
import { address as addressUtils } from "@rentiohq/web-shared/dist/utils";
import { EField } from "./schema.profileExtra.types";

export const getInitialValues = (user: IUser) => {
  const profileData = utils.object.removeEmpty(user);

  const {
    personalContact: contact = {
      dateOfBirth: "",
      placeOfBirth: "",
      countryOfBirth: "",
    },
  } = profileData;

  let placeOfBirth = undefined;
  if (contact?.placeOfBirth) {
    placeOfBirth = {
      city: contact.placeOfBirth,
      country: contact.countryOfBirth,
    };
  }

  return {
    [EField.DateOfBirth]: contact?.dateOfBirth,
    [EField.Nationality]: contact?.nationality,
    [EField.PlaceOfBirth]: addressUtils.addressObjToString(placeOfBirth || {}),
    [EField.countryOfBirth]: contact?.countryOfBirth,
  };
};
